module.exports = __webpack_public_path__ + "static/img/me_bg_study@2x.9cf964e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/person/me_bg_study@2x.png
// module id = 865X
// module chunks = 1